<mat-form-field appearance="outline">
  <mat-label>{{ field.key| translate }}</mat-label>
  <input type="text"
         placeholder="{{ field.key | translate }}"
         matInput
         [formControl]="field.control"
         [transform]="toDbModel.bind(this)"
         [matAutocomplete]="auto">
  <mat-icon matSuffix class="keyboard">keyboard</mat-icon>
  <mat-icon matSuffix class="clear"
            (click)="clearInput()"
            *ngIf="canShowClearBtn()">
    clear
  </mat-icon>
  <mat-autocomplete #auto="matAutocomplete"
                    [displayWith]="displayFn">
    <mat-option *ngFor="let item of $selectItems | async" [value]="item">
      {{ item.text }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
